// Pasos del asistente de sitio (dirección, plan, módulos y confirmar), comunes al alta y a «Nuevo sitio».
// Cada paso guarda en el servidor y navega a la URL que la página deja en data-siguiente.
document.addEventListener("DOMContentLoaded", () => {
	const raiz = document.getElementById("asistente");
	if (!raiz) return;

	const $ = (id) => document.getElementById(id);
	const vista = raiz.dataset.vista;
	const sitio = raiz.dataset.sitio;
	const siguiente = $("btn-siguiente");
	const API = "tereket_portal.api.sitios.";

	const irAlSiguiente = (nombre) => { window.location.href = raiz.dataset.siguiente.replace("{sitio}", encodeURIComponent(nombre)); };

	// Envuelve la acción del botón: deshabilita mientras trabaja y muestra el error del servidor.
	function alPulsarSiguiente(accion) {
		siguiente.addEventListener("click", async () => {
			$("error-general").textContent = "";
			siguiente.disabled = true;
			try {
				await accion();
			} catch (err) {
				if (err.campo && $("error-" + err.campo)) tereket.errorCampo(err.campo, err.mensaje);
				else $("error-general").textContent = err.mensaje;
				siguiente.disabled = false;
			}
		});
	}

	// ---- Dirección: subdominio con comprobación en directo
	if (vista === "direccion") {
		const campo = $("subdominio");
		let temporizador, ultima = 0;
		const mostrar = (ok, mensaje) => {
			$("ok-subdominio").hidden = !ok;
			$("ok-subdominio").textContent = ok ? "✓ " + mensaje : "";
			tereket.errorCampo("subdominio", ok ? "" : mensaje);
		};
		const comprobar = () => {
			clearTimeout(temporizador);
			const valor = campo.value.trim();
			mostrar(false, "");
			if (!valor) return;
			temporizador = setTimeout(async () => {
				const mia = ++ultima;
				try {
					const r = await tereket.llamar(API + "comprobar_subdominio", { subdominio: valor });
					if (mia === ultima) mostrar(r.disponible, r.mensaje);
				} catch (e) { /* la validación definitiva la hace «Siguiente» */ }
			}, 400);
		};
		campo.addEventListener("input", () => { campo.value = campo.value.toLowerCase(); comprobar(); });
		if (campo.value) comprobar();
		campo.addEventListener("keydown", (e) => { if (e.key === "Enter") siguiente.click(); });
		alPulsarSiguiente(async () => {
			const r = await tereket.llamar(API + "guardar_subdominio", { subdominio: campo.value.trim(), sitio });
			irAlSiguiente(r.sitio);
		});
	}

	// ---- Plan y periodicidad (los precios llegan ya pintados por el servidor)
	if (vista === "plan") {
		let periodicidad = $("periodicidad").dataset.valor;
		let plan = $("planes").dataset.plan;
		const pintar = () => {
			document.querySelectorAll("[data-periodicidad]").forEach((b) => b.classList.toggle("active", b.dataset.periodicidad === periodicidad));
			document.querySelectorAll("[data-periodo]").forEach((s) => { s.hidden = s.dataset.periodo !== periodicidad; });
			document.querySelectorAll(".tk-plan").forEach((b) => {
				b.classList.toggle("elegido", b.dataset.plan === plan);
				b.setAttribute("aria-pressed", b.dataset.plan === plan);
			});
		};
		document.querySelectorAll("[data-periodicidad]").forEach((b) => b.addEventListener("click", () => { periodicidad = b.dataset.periodicidad; pintar(); }));
		document.querySelectorAll(".tk-plan").forEach((b) => {
			const elegir = () => { plan = b.dataset.plan; tereket.errorCampo("plan", ""); pintar(); };
			b.addEventListener("click", elegir);
			b.addEventListener("keydown", (e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); elegir(); } });
		});
		pintar();
		alPulsarSiguiente(async () => {
			if (!plan) throw { mensaje: "Elige un plan para continuar.", campo: "plan" };
			await tereket.llamar(API + "guardar_plan", { sitio, plan, periodicidad });
			irAlSiguiente(sitio);
		});
	}

	// ---- Módulos: ninguno es obligatorio. Las dependencias las calcula el servidor (previsualizar_modulos).
	if (vista === "modulos") {
		const cajas = Array.from(document.querySelectorAll("#modulos input[type=checkbox]"));
		const elegidos = () => cajas.filter((c) => c.checked && !c.disabled).map((c) => c.value);
		let secuencia = 0;

		function pintar(r) {
			cajas.forEach((c) => { if (!c.disabled) c.checked = r.seleccion.includes(c.value); });
			document.querySelectorAll("[data-motivo]").forEach((el) => {
				const texto = r.motivos[el.dataset.motivo];
				el.textContent = texto ? "(" + texto + ")" : "";
				el.hidden = !texto;
			});
		}

		cajas.forEach((caja) => caja.addEventListener("change", async () => {
			const mia = ++secuencia;
			tereket.errorCampo("modulos", "");
			$("nota-sin-modulos").hidden = elegidos().length > 0;
			try {
				const r = await tereket.llamar(API + "previsualizar_modulos", { sitio, seleccion: JSON.stringify(elegidos()), tocado: caja.value });
				if (mia !== secuencia) return; // llegó otra respuesta más reciente
				pintar(r);
			} catch (err) {
				if (mia !== secuencia) return;
				caja.checked = !caja.checked;
				tereket.errorCampo("modulos", err.mensaje);
			}
			$("nota-sin-modulos").hidden = elegidos().length > 0;
		}));

		alPulsarSiguiente(async () => {
			await tereket.llamar(API + "guardar_modulos", { sitio, modulos: JSON.stringify(elegidos()) });
			irAlSiguiente(sitio);
		});
	}

	// ---- Confirmar y pagar
	if (vista === "confirmar") {
		alPulsarSiguiente(async () => {
			const r = await tereket.llamar(API + "iniciar_pago", { sitio });
			window.location.href = r.redirigir;
		});
	}
});
